export function clearAllTimeouts() {
    let id = window.setTimeout(() => {
    }, 0);
    while (id--) {
        window.clearTimeout(id);
    }
}